import { getBackendUrl } from "@Utils";
import axiosWrapper from "./axiosWrapper";

export const handleUpgrageButtonClick =
  ({ portalData, userDetails }) =>
  async () => {
    const signinData = await axiosWrapper.post(`${getBackendUrl()}/accounts/getSigninData`, {});
    if (signinData.data.frontendUrl) {
      const url = new URL(window.location.href);
      url.host = signinData.data.frontendUrl;
      url.pathname = "/signupflow";

      const urlParams = new URLSearchParams(location?.search);
      urlParams.set("origin", portalData.frontendUrl);
      if (portalData.customerData?.partnerId) {
        urlParams.set("partnerId", portalData.customerData.partnerId);
        if (portalData.customerData.partnerId == userDetails.partnerData?.cf_partner_id) {
          urlParams.set("asPartner", true);
        }
      }
      urlParams.set("createPortal", true);
      url.search = urlParams.toString();
      window.location.href = url.toString();
    }
  };
